// 捐赠成功页广告位配置：partners → slots → ads 三层结构
// - partners: 多个广告供应商，按 probability 加权随机选定一个为页面主供应商
// - slots:    每个供应商在不同广告位下的素材集合（如 payment_success / banner / popup）
// - ads:      同一 slot 下的多个广告素材，再按 probability 加权随机一个

export const PAYMENT_SUCCESS = {
  partners: {
    nuanwa: {
      name: '暖哇',
      probability: 90,
      slots: {
        payment_success: {
          ads: {
            PAYMENT_SUCCESS_ADS_A: {
              id: 'PAYMENT_SUCCESS_ADS_A',
              imgUrl: require('@/assets/info/payment_bg1.gif'),
              eventName: 'fund-subscribe-click-nuamwa',
              content: `{"key":"捐款完成后弹窗","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025071702',
              partners: '暖哇',
              probability: 50,
            },
            PAYMENT_SUCCESS_ADS_B: {
              id: 'PAYMENT_SUCCESS_ADS_B',
              imgUrl: require('@/assets/info/payment_bg1_1.gif'),
              eventName: 'fund-subscribe-click1b-nuamwa',
              content: `{"key":"捐款完成后弹窗1b","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026042317',
              partners: '暖哇',
              probability: 0,
            },
          },
        },
      },
    },
    yixin: {
      name: '毅新',
      probability: 5,
      slots: {
        payment_success: {
          ads: {
            PAYMENT_SUCCESS_ADS_A: {
              isWatch:false,
              id: 'PAYMENT_SUCCESS_ADS_A',
              imgUrl: require('@/config/assets/yixin/payment-success2/payment-success2.png'),
              eventName: 'fund-subscribe-click-yixin',
              content: `{"key":"捐款完成后弹窗","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168368014434.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY4MDE0NDM0IiwidHMiOiIxNzgxNTg3NTc1IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImQ1MjNiNzY5LTc2ZmEtNDI4YS04MzAwLTUzOTVmNWVjMDIwOFwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYyXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=d523b769-76fa-428a-8300-5395f5ec0208&abt=0',
              partners: '毅新',
              probability: 100,
            },
          },
        },
      },
    },
    haohai: {
      name: '浩海',
      probability: 5,
      slots: {
        payment_success: {
          ads: {
            PAYMENT_SUCCESS_ADS_A: {
              isWatch:false,
              id: 'PAYMENT_SUCCESS_ADS_A',
              imgUrl: require('@/config/assets/haohai/payment-success2/2.png'),
              eventName: 'fund-subscribe-click-haohai',
              content: `{"key":"捐款完成后弹窗","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          },
        },
      },
    },
  },
}

export const paymentSuccessData = [
  'fund-subscribe-click-yixin',
  'fund-subscribe-click-haohai'
]
